export { default } from './ArrowChar';
